export default {
    key: "member_tier",
    id: "id",
    action: ["create", "edit", "delete"],
    export: ["excel"],
    excel: {
        //max_row:"50000"
    },
    sort: {
        field: "id",
        order: "desc"
    },
    sort_fields: [],
    filters: {},

    options: {},
    fields: [
        // { key: "id", field:"rsr_id", width:50},
        {key: "tier"},
        {key: "tierName"},
        {key: "monthlyChargingLimit"},
        {type: "action-btn", privilege: ["EDIT_MEMBER_TIER"]},
    ],
    structure: [
        ["tier"],
        ["tierName"],
        ["monthlyChargingLimit"]
    ]
}